import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { channelApi, type ChannelListType } from './channelApi';

// Define the type for state
interface AccountState {
  channelList: ChannelListType[];
}

const initialState: AccountState = { channelList: [] };

const channelSlice = createSlice({
  name: 'channel',
  initialState,
  reducers: {
    setChannelList: (state, action: PayloadAction<any>) => {
      state.channelList = action.payload;
    },
    setChannelStateInitial: (state) => {
      state.channelList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(channelApi.endpoints.getChannelList.matchFulfilled, (state, action) => {
        state.channelList = action?.payload.list ?? null;
      })
      .addMatcher(channelApi.endpoints.createChannel.matchFulfilled, (state, action) => {
        state.channelList = state.channelList
          ? [...state.channelList, action.payload]
          : [action.payload];
      });
  },
});

export const { setChannelList, setChannelStateInitial } = channelSlice.actions;
export default channelSlice.reducer;
